var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.63925 2.06811C10.0294 1.67723 10.6623 1.67693 11.0528 2.06746L12.4634 3.47808C12.854 3.8686 12.8542 4.50206 12.4641 4.89295L7.10641 10.2605C6.97095 10.3962 6.79937 10.4901 6.61211 10.531L4.81139 10.9237C4.1006 11.0787 3.46771 10.446 3.6217 9.7344L4.01192 7.93092C4.05251 7.74332 4.14617 7.57137 4.28171 7.43557L9.63925 2.06811Z",
    stroke: "#A0C6DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.22949 3.76367L11.0543 6.58851",
    stroke: "#A0C6DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.59668 14.2783H12.7967",
    stroke: "#A0C6DB",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.5c7180d7ddc883c6e7a8fffdb74cd415.svg";
export { ForwardRef as ReactComponent };